module.exports = __webpack_public_path__ + "img/down.e113f15c.svg";